import React from 'react';
import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';

import Alert from 'react-bootstrap/Alert';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import GCOrders from './GCOrders.js'

import Checkbox from '@material-ui/core/Checkbox';
import RestServices from '../services/RestServices.js';

const statusArray =[
    { key: 'Active', value: 'active' },
    { key: 'Disabled', value: 'disabled' },
]

class GCDetails extends React.Component {
    _isMounted = false;
    state = {
        description:this.props.gcard.description,
        tnc_content:this.props.gcard.tnc_content,
        redeem:this.props.gcard.redeem,
        status:this.props.gcard.status?this.props.gcard.status:'active',
        sku:this.props.gcard.sku,
        offer:this.props.gcard.offer,
        dtic:this.props.gcard.dtic,
        IGMP:this.props.gcard.IGMP,
        DBCP:this.props.gcard.DBCP,
        IBMP:this.props.gcard.IBMP,
        top_brand:this.props.gcard.top_brand?this.props.gcard.top_brand:false,

        alertMessage:'',
        alert:0,
        showLoading:false,
        MasterGiftCard:this.props.gcard?this.props.gcard.MasterGiftCard:'',
    };
    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this._isMounted = true;
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
        if(event.target.name ==='offer'){
            this.updatedIGMP(event.target.value,this.state.DBCP)
        }
        if(event.target.name ==='dtic'){
            this.updatedICIGMP(event.target.value,this.state.DBCP)
        }
        if(event.target.name ==='DBCP'){
            this.updatedIGMP(this.state.offer,event.target.value)
        }
        
    };

    updatedICIGMP(OfferValue,DBCPValue){
        let DBCP = DBCPValue > 0 ? DBCPValue :0
        let offer = OfferValue > 0 ? OfferValue :0
        var IBMP = (parseFloat(DBCP)-parseFloat(offer)).toFixed(2)
        this.setState({ ['IGMP']: IBMP });
    }

    updatedIGMP(OfferValue,DBCPValue){
        let DBCP = DBCPValue > 0 ? DBCPValue :0
        let offer = OfferValue > 0 ? OfferValue :0
        var IBMP = (parseFloat(DBCP)-parseFloat(offer)).toFixed(2)
        this.setState({ ['IBMP']: IBMP });
    }



    
    async updateWoohooProductDetailDB(bodyData,productSKU){
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/updateGCProfile?productSKU='+productSKU
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false
                    });
                }
                
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    updateGCProfile = () =>{
        this.setState({showLoading: true });
        let bodyData = {
        description: this.state.description,
        tnc_content: this.state.tnc_content,
        redeem: this.state.redeem,
        offer: this.state.offer,
        dtic: this.state.dtic,
        DBCP:this.state.DBCP,
        IBMP:this.state.IBMP,
        IGMP:this.state.IGMP,
        top_brand:this.state.top_brand,
        status: this.state.status?this.state.status:'active',
        }
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/updateGCProfile?productSKU='+this.state.sku
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({showLoading: true });
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 2,
                            alertMessage: responseData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({showLoading: false,alert: 1, alertMessage:'GC Updated...'  });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                        this.setState({ showLoading:false,alert: 2, alertMessage: err.message });
                }
            });
            

    }
    render() {
        return (
            <Container className="no_padding">
                {this.state.showLoading && <Spinner animation="border" />}
                
                <div><hr /></div>
                <Tabs
                    defaultActiveKey="editProfile"
                    id="uncontrolled-tab-example"
                >
                    <Tab eventKey="editProfile" title="GC Detail">
                        <div>
                            <hr />
                        </div>
                <Row>
                    <Col>
                        <h5>{this.props.gcard.name} Details</h5>
                        <hr />
                    </Col>
                </Row>

                <Row>
                                <Col>
                                    <p><b>DBCP:</b>Discount by Company Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>DTSP:</b>Discount to Store Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>DTIC:</b>Discount to InstaGyfts Customers</p>
                                </Col>
                                <Col>
                                    <p><b>IBMP:</b>Indiabuys Margin Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>IGMP:</b>InstaGyfts Margin Percentage</p>
                                </Col>
                            </Row>
                <Row>
                    <Col>
                        <hr />
                    </Col>
                </Row>

                
                <Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Status</Form.Label>
                        <select
                        className="form-control"
                        name="status"
                        onChange={this.onChangeValues}
                        value={this.state.status}
                        >
                        {statusArray.map((status) => (
                            <option
                                key={status.value}
                                value={status.value}
                            >
                                {status.key}
                            </option>
                        ))}
                        </select>
                    </Form.Group>
                </Form.Row>
                
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Top Brand</Form.Label>
                        <div className='form-control' style={{border:'0px', padding:'0', margin: '0'}}>
                        <Checkbox
                        label={'Top Brand'}
                        key={'top_brand'}
                        name={'top_brand'}
                        checked={this.state.top_brand}
                        onChange={(e) =>
                            this.setState({top_brand: !this.state.top_brand })
                        }
                        />
                        </div>
                    </Form.Group>
                </Form.Row>


                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>DBCP (%)</Form.Label>
                        <Form.Control
                            placeholder="Enter offer"
                            type="number"
                            name="DBCP"
                            value={this.state.DBCP}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>DTSP (%)</Form.Label>
                        <Form.Control
                            placeholder="Enter offer"
                            type="number"
                            name="offer"
                            value={this.state.offer}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>DTIC (%)</Form.Label>
                        <Form.Control
                            placeholder="Enter offer"
                            type="number"
                            name="dtic"
                            value={this.state.dtic}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>IBMP (%)</Form.Label>
                        <Form.Control
                            disabled='disabled'
                            type="number"
                            name="IBMP"
                            value={this.state.IBMP}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>IGMP (%)</Form.Label>
                        <Form.Control
                            disabled='disabled'
                            type="number"
                            name="IGMP"
                            value={this.state.IGMP}
                        />
                    </Form.Group>
                </Form.Row>

                </Row>
                <Row>
                <Form.Row>
                   <Form.Group as={Col}>
                        <Form.Label>DESCRIPTION</Form.Label>
                        <Form.Control
                            placeholder="Enter description"
                            type="text"
                            name="description"
                            value={this.state.description}
                            onChange={this.onChangeValues}
                            as="textarea" rows={15}
                        />
                    </Form.Group>
                </Form.Row>
                
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>TERMS & CONDITIONS</Form.Label>
                        <Form.Control
                            placeholder="Enter content"
                            type="text"
                            name="tnc_content"
                            value={this.state.tnc_content}
                            onChange={this.onChangeValues}
                            as="textarea" rows={15}
                        />
                    </Form.Group>
                </Form.Row>
                
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>HOW TO REDEEM</Form.Label>
                        <Form.Control
                            placeholder="Enter how to redeem"
                            type="text"
                            name="redeem"
                            value={this.state.redeem}
                            onChange={this.onChangeValues}
                            as="textarea" rows={5}
                        />
                    </Form.Group>
                </Form.Row>
                </Row>
                <Row>
                <Form.Row>
                    <Col>
                    <Button
                        variant="primary"
                        type="submit"
                        onClick={this.updateGCProfile}
                    >
                        Update GC
                    </Button>
                    </Col>
                </Form.Row>
                </Row>
                <Row>
                <Col>
                {this.state.alert === 2 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}
                {this.state.alert === 1 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}
                </Col>
                </Row>
                
                        
                    </Tab>

                    
                    <Tab eventKey="GCOrders" title="GC Orders">
                        <div>
                            <hr />
                        </div>
                        <GCOrders gcard={this.props.gcard} />
                    </Tab>

                    
                </Tabs>
            </Container>
        );
    }
}

export default GCDetails;
